const ITEMS = [
  "FOOD FIRST",
  "EVIDENCE GRADED A—X",
  "SAFETY GATED",
  "NO SPONSORED PILLS",
  "100% ANONYMOUS",
  "ZINDA BANDA",
  "UAE + INDIA PLATES",
  "TWO SUPPLEMENTS MAX",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="overflow-hidden border-y border-ink/10 bg-sand py-4" data-testid="editorial-marquee" aria-hidden>
      <div className="zb-marquee-track">
        {row.map((t, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="font-mono text-xs sm:text-sm uppercase tracking-[0.28em] text-ink/70 px-6">{t}</span>
            <span className="h-1.5 w-1.5 rounded-full bg-clay" />
          </span>
        ))}
      </div>
    </div>
  );
}
